module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/_is-object.js
// module id = ../../../../core-js/modules/_is-object.js
// module chunks = 0